import { useApi } from './index';

// Holders Summary
export const useHoldersSummary = () => {
  return useApi('/holders/summary');
};

// Top Holders
export const useHoldersTop = (limit = 50) => {
  return useApi(`/holders/top?limit=${limit}`);
};

// Holders Retention
export const useHoldersRetention = (quantiles = 'median,mean', windows = '30,60,90') => {
  return useApi(`/holders/retention?quantiles=${quantiles}&windows=${windows}`);
};

// Holders Risk Concentration
export const useHoldersRisk = (threshold = 5) => {
  return useApi(`/holders/risk/concentration?threshold=${threshold}`);
};
